import { ReactElement, useState } from "react"
import { ColumnShape } from "react-base-table"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons"

import { Modal } from "@wfp/ui"

import { IReportObs } from "../../../../interfaces/markets"

type Props = {
  column: ColumnShape<IReportObs>
  description?: string
}

const HeaderCell = ({ column, description }: Props): ReactElement => {
  const [isPopoverOpen, setIsPopoverOpen] = useState<boolean>(false)

  return (
    <>
      <div className="flex items-center justify-between">
        {column.title}
        <FontAwesomeIcon
          icon={faCircleInfo}
          color="#bbb"
          size="sm"
          className="hover:text-[var(--interactive-01)] p-1"
          onClick={evt => {
            evt.stopPropagation()
            evt.preventDefault()
            setIsPopoverOpen(true)
          }}
        />
      </div>

      <Modal
        lazyLoad
        open={isPopoverOpen}
        modalHeading={column.title}
        onRequestClose={() => setIsPopoverOpen(false)}
        passiveModal
      >
        <div className="whitespace-pre-line leading-6 text-justify">{description}</div>
      </Modal>
    </>
  )
}

export default HeaderCell
